var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import PurchaseService from '../../../api/PurchaseService';
import CommonService from '../../../api/CommonService';
import HeaderItem from '../../../components/HeaderItem';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.orderTypeOptions = [
            { name: '库存报损单', value: 38 },
            { name: '库存报溢单', value: 37 },
        ];
        _this.organList = [];
        _this.depotList = [];
        return _this;
    }
    default_1.prototype.watchOrganId = function (newValue, oldValue) {
        if (newValue && this.handleStatus === 1) {
            this.formData.depot_id = '';
            this.getDepotList();
        }
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        if (this.handleStatus === 1) {
            this.getOrganList();
        }
    };
    default_1.prototype.depotChange = function (value) {
        this.orderChange(value, 'depot_id');
    };
    default_1.prototype.organChange = function (value) {
        this.orderChange(value, 'organ_id');
    };
    default_1.prototype.orderTypeChange = function (value) {
        this.orderChange(value, 'order_type');
    };
    default_1.prototype.orderChange = function (value, type) {
        var _this = this;
        if (!this.data.length) {
            this.formData[type] = value;
            return;
        }
        var typeObj = {
            order_type: '单据',
            organ_id: '机构',
            depot_id: '仓库',
        };
        this.$confirm("\u5207\u6362" + typeObj[type] + "\u4F1A\u6E05\u7A7A\u5DF2\u7EF4\u62A4\u7684\u6570\u636E\uFF0C\u786E\u8BA4\u6E05\u7A7A\u5417\uFF1F", '', {
            customClass: 'confirm',
            center: true,
        })
            .then(function () {
            _this.formData[type] = value;
            _this.$emit('emptyData');
        })
            .catch(function () { });
    };
    default_1.prototype.getDepotList = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            var data = res.data.data;
            _this.depotList = data || [];
            (res.data.data || []).some(function (item) {
                if (item.is_organ_default == 1) {
                    _this.formData.depot_id = item.depot_id;
                }
            });
        });
    };
    default_1.prototype.getOrganList = function () {
        var _this = this;
        this.commonService &&
            this.commonService.getOrganList().then(function (res) {
                var data = res.data.data;
                _this.organList = data || [];
                if (_this.organList.length) {
                    _this.formData.organ_id = _this.organList[0].organ_id;
                }
            });
    };
    __decorate([
        Prop({
            required: true,
            type: Number,
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({})
    ], default_1.prototype, "data", void 0);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchOrganId", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
